import React from 'react';

const ManufacturersWarrantyIcon = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 29H2.76667C2.34324 29 2 28.6518 2 28.2222V2.77778C2 2.34823 2.34324 2 2.76667 2H20.6192C20.8251 2 21.0225 2.08407 21.1666 2.23328L24.7808 5.9732C24.9213 6.11857 25 6.31006 25 6.5136C25 8.05531 25 8.81291 25 13"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19.9749 2.77563V6.67794C19.9749 7.10899 20.3243 7.45841 20.7553 7.45841H24.6576"
      stroke="#00619E"
      strokeWidth="2"
    />
    <path
      d="M7 12H20"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 17H16"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 22H14"
      stroke="#00619E"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19 19.6C20.8333 19.6 22.0556 18.95 24.5 17C26.9444 18.95 28.1667 19.6 30 19.6C30 28.7 24.5 30 24.5 30C24.5 30 19 28.7 19 19.6Z"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M22.6666 23.5L23.8888 24.8L26.3333 22.2"
      stroke="#00AED9"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ManufacturersWarrantyIcon;
